import React, { useCallback, useRef, useContext } from 'react';
import { BluebookAnnotationsContext } from 'chameleon/packages/blue-book-player/state/BluebookAnnotationsContext';
import NotesItem from 'chameleon/packages/blue-book-player/library/NotesColumn/NotesList/NotesItem';
import { findMatchingElement } from 'chameleon/packages/blue-book-player/library/NotesColumn/NotesList/utils';

const NotesList = ({ learnosityItemReference, itemRefAnnotations }) => {
  const {
    state: { annotations, activeId },
    annotationManager: { setActiveId },
  } = useContext(BluebookAnnotationsContext);
  const listRef = useRef(null);

  const handleSetActive = useCallback(
    (id) => {
      const annotation = annotations.find((item) => item.id === id);
      if (!annotation) return;

      const matchingElement = findMatchingElement(
        annotation,
        learnosityItemReference,
      );

      if (matchingElement) {
        matchingElement.classList.add(
          'lrn-annotations-texthighlight-marking--active',
        );
      }

      setActiveId(id);
    },
    [annotations, setActiveId],
  );

  return (
    <div ref={listRef} className="notes-list ">
      {itemRefAnnotations.map(({ id, annotation, highlight }) => (
        <NotesItem
          key={id}
          id={id}
          title={highlight.selection}
          annotation={annotation}
          color={highlight.color}
          isActive={id === activeId}
          onSetActive={handleSetActive}
          learnosityItemReference={learnosityItemReference}
        />
      ))}
    </div>
  );
};

export default NotesList;
